/*** IMPORTS FROM imports-loader ***/
var define = false;

/* global jarallax */

import $ from 'jquery';
import 'jarallax/dist/jarallax';

function setupParallax(container) {
  const $parallax = $(container).find('.parallax');
  if ($parallax.length) {
    $parallax.each((idx, el) => {
      jarallax(el, { speed: 0.5 });
    });
  }
}

export { setupParallax };

